import Icon, { IconProps } from '../atoms/Icon';

export function IconContent(props: IconContentProps) {
    return <Icon {...props} />;
}

export type IconContentProps = IconProps;

export default IconContent;
